module.exports = __webpack_public_path__ + "static/media/02.a673ab97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/02.jpg
// module id = 22
// module chunks = 0